/**
 * --------------------------------------------------------------------------
 * NJ : Select.js
 * --------------------------------------------------------------------------
 */

import { Data, Manipulator, Testing } from 'nj-utils';
import AbstractFormBaseInput from './AbstractFormBaseInput';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'radio';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;

const SELECTOR = 'select';

const DEFAULT_CONFIG = {
  requiredClasses: ['form-control||custom-select']
};

class Select extends AbstractFormBaseInput {
  constructor(element, config) {
    super(Select, element, Manipulator.extend(true, DEFAULT_CONFIG, config));
    this.element = element;

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }

    // floating labels will cover the options, so trigger them to be above (if used)
    this.addIsFilled();
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static matches(element) {
    return element.tagName === 'SELECT';
  }

  static rejectMatch(component, element) {
    Testing.assert(
      this.element,
      this.matches(element),
      `${component} component element ${Testing.describe(
        element
      )} is invalid for <select>.`
    );
  }

  // Static
  static selector = SELECTOR;
}

export default Select;
